const filters = {
	formatStripeCurrency(value: any) {
		return 100 * parseFloat(parseFloat(value).toFixed(2));
	},

	formatCurrencyStr(value: any) {
		return "$ " + parseFloat(value).toFixed(2);
	},

	currency(value: any) {
		const formatter = new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: "USD",
		});

		return formatter.format(value);
	},
};

export default filters;
